import React from "react";
import AppTemplate from "../components/Page404";

const Page404: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default Page404;
